module.exports = __webpack_public_path__ + "/static/assets/dd55f4c6c20f5d25e520b6f5bfb090c5.svg";